<template>
  <v-card elevation="0">
    <v-row>
      <v-col :cols="col">
        <v-avatar :size="avatar_size">
          <img src="../assets/profile.png" alt="John">
        </v-avatar>
      </v-col>
      <v-col :cols="12-col" class="d-flex flex-column justify-center">
        <v-card-title class="text-h4 pl-2 font-weight-medium">Osman Tamer</v-card-title>

        <v-card width="70" elevation="0" class="ml-3">
          <v-row>
            <v-col class="px-0">
              <v-btn color="#0072b1" plain icon large href="https://www.linkedin.com/in/osman-tamer/" target="_blank">
                <v-icon large>mdi-linkedin</v-icon>
              </v-btn>
            </v-col>
            <v-col class="px-0">
              <v-btn color="black" plain icon large href="https://github.com/osmantamer" target="_blank">
                <v-icon large>mdi-github</v-icon>
              </v-btn>
            </v-col>
            <!-- <v-col class="px-0 d-flex align-center ml-1">
              <v-card height="34" width="34" class="rounded-circle" elevation="0" style="cursor: pointer;">
                <v-img src="/img/projects/narlink.png" @click="to()" ></v-img>
              </v-card>
            </v-col> -->
          </v-row>
        </v-card>
        <v-card-text class="pl-2 pb-0 font-weight-bold text-h6">Computer Science And Engineering</v-card-text>
        <v-card-subtitle class="pl-2">Keywords: Machine Learning, Big Data, Python, VueJS, Django, Researcher</v-card-subtitle>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    to(){
      window.open('https://narl.ink/osmantamer')
    }
  },
  computed: {
    col () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 12
        case 'sm': return 5
        case 'md': return 4
        case 'lg': return 3
        case 'xl': return 2
      }
    },
    avatar_size () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 200
        case 'sm': return 260
        case 'md': return 260
        case 'lg': return 260
        case 'xl': return 260
      }
    },
  },
}
</script>

<style>
.word {
  word-wrap: break-word;
}
</style>